import { useInsightsFilters } from "./useInsightsFilters";
import { TRACES_NAMESPACE } from "../utils/filterPersistence";

/**
 * Filter + metadata state for the Traces page. Same shape and behaviour as the
 * Insights filters, but persisted under its own namespace so the two pages keep
 * independent slices — a chart drill-down seeds this slice (see
 * `seedTracesFilters`) without disturbing the Insights filters, and toggling
 * between the pages preserves each view (#1402).
 *
 * `groupByKey` / `scoreMetric` in the returned shape are Insights-only view
 * state and are simply unused here.
 *
 * Defaults to "all time" (like the original Traces page) rather than the
 * Insights last-30-days window — a direct visit shouldn't silently hide older
 * traces. A drill-down still lands with the window inherited from Insights,
 * because `seedTracesFilters` writes an explicit window before navigating.
 */
export function useTracesFilters() {
  return useInsightsFilters({
    namespace: TRACES_NAMESPACE,
    defaultWindow: { kind: "all" },
  });
}
